<script setup>
import { computed } from 'vue';
import { uniqBy } from 'lodash';
import { ensurePath } from '../models/estructura_escolar/Path';

const props = defineProps({
  path: { type: Object, default: null },
  quitarDuplicados: { type: Boolean, default: true },
  abreviado: { type: Boolean, default: true },
});

const pathFinal = computed(() => {
  let pathArray = ensurePath(props.path).toPathArray();
  pathArray.forEach((paso) => {
    if (!props.abreviado) {
      paso.label = paso.nombre;
    }
  });

  if (props.quitarDuplicados) {
    pathArray = uniqBy(pathArray, 'label');
  }

  return pathArray;
});
</script>

<template>
  <span v-if="path" class="label label-default path">
    <span v-for="modelo in pathFinal" :key="modelo" class="modelo">
      {{ modelo.label }}
    </span>
  </span>
</template>

<style lang="scss" scoped>
@import "@/../assets/stylesheets/cifra/vars/main.scss";

$muted: lighten($text-color, 20%);

.modelo {
  color: $muted;

  .path:hover & {
    color: $text-color;
  }

  &:last-child {
    font-weight: 700;
    color: $text-color;
  }
}

.modelo + .modelo::before {
  content: ' / ';
  color: $muted;
  padding-left: 4px;
  padding-right: 4px;
}
</style>
